module.exports = __webpack_public_path__ + "img/monthlyParkingLot.f1103ecc.png";